import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserSalesMessage } from 'app/services/sales.service';
import { MailHistoryModalComponentViewModel } from './mail-history-modal.viewmodel';
import { MessageModalComponentViewModel } from './message-modal.viewmodel';

@Component({
	selector: 'mail-history-modal',
	templateUrl: 'mail-history-modal.html'
})
export class MailHistoryModalComponent {

  @Input() viewModel: MailHistoryModalComponentViewModel;


}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/mail-history-modal.ts